import React from 'react';

import MUIButton, { ButtonProps as MUIButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { LinkProps } from 'react-router-dom';

export type BtnType = 'primary' | 'secondary' | 'tertiary' | 'label';

export type ButtonProps = MUIButtonProps & {
  btntype?: BtnType;
  // These two props are valid but not listed in MUIButtonProps for some reason
  component?: React.ForwardRefExoticComponent<LinkProps>;
  to?: string;
};

const StyledButton = styled(MUIButton)(() => ({
  textTransform: 'none',
  letterSpacing: '0',
}));

const Button: React.FC<ButtonProps> = (props) => {
  const { children, ...buttonProps } = props;

  return <StyledButton {...buttonProps}>{children}</StyledButton>;
};

export default Button;
